import React from "react";
import Modal from "../../../../parts/modal-new";

const TestModal = () => {
  return (
    <Modal title={"This is a test Modal"}>
      <div className="body w-80 h-80">
        <p>This is where the body goes</p>
      </div>
      <footer>
        <a
          role="button"
          data-button-type="text-white"
          data-action="cancel"
          href="/actions/refresh?modal[type]="
        >
          Cancel
        </a>
        <a
          role="button"
          data-button-type="primary"
          href="/actions/refresh?modal[type]="
        >
          Save
        </a>
      </footer>
    </Modal>
  );
};

export default TestModal;
